import { Tracker } from "@aircall/tracker";
import { RUDDERSTACK_API_KEY } from "./environment.constants";

export const tracker = new Tracker({
  key: RUDDERSTACK_API_KEY,
});
